import localeAntd from 'antd/es/locale/en_US'

const messages = {
  'title.helmet.Leads': 'Manage Leads',
  'title.helmet.services': 'Manage Services',
  'text.servicesList': 'Services List',
  'title.helmet.dailyReports': 'Manage Daily Reports',
  'form.user.placeholder.searchEnquiry': 'Search Enquiry',
  'title.helmet.Enquiry': 'Manage Enquiry',
  'text.enquiryList': 'Enquiry List',
  'text.DailyReportList': 'Daily Report List',
  'text.custommessage.enquiryData': 'No Enquiry Data Found',
  'text.viewEnquiry.sno': 'S.No',
  'text.viewEnquiry.name': 'Name',
  'text.viewEnquiry.email': 'Email',
  'text.viewEnquiry.mobile': 'Mobile',
  'text.viewEnquiry.subject': 'Subject',
  'text.viewEnquiry.website': 'Website',
  'text.viewEnquiry.enquiry_date': 'Enquiry Date',
  'title.helmet.Accounts': 'Manage Accounts',
  'text.leadList': 'Lead List',
  'title.helmet.User': 'Manage Users',
  'text.userList': 'User List',
  'text.updateLeads': 'Update Leads',
  'text.removeLead': 'Remove Lead',
  'text.removeLead.description': 'Are you sure you want to delete this lead?.',
  'text.addLead': 'Add Lead',
  'action.createLeads': 'Create Leads',
  'text.viewleads.sno': 'Sno.',
  'text.viewleads.business_name': 'Business Name',
  'text.viewleads.emailid': 'Email Id',
  'text.viewleads.mobile': 'Mobile',
  'text.viewleads.type': 'Type',
  'text.viewleads.lead_owner': 'Lead Owner',
  'text.viewleads.status': 'Status',
  'text.viewleads.contact_name': 'Contact Name',
  'text.custommessage.leadsData': 'No Leads to show',
  'text.custommessage.accountsData': 'No Accounts to show',
  'form.user.placeholder.searchLeads': 'Search by Business Name or Contact Name or Email Or Mobile',
  'form.user.placeholder.searchAccounts': 'Search by Business Name or Contact Name or Email',
  'text.accountList': 'Accounts List',
  'text.productName': 'Product Name',
  'text.created_at': 'Created At',
  'text.custommessage.productNameList': 'No products found',
  'text.AddProducts': 'Add Products',
  'action.addProducts': 'Add Products',
  'form.placeholder.product_name': 'Products Name',
  'form.label.product_name': 'Products Name',
  'form.placeholder.Products': 'Products Name',
  'form.placeholder.panNumber': 'PAN Number',
  'form.placeholder.aadhaarNumber': 'Aadhaar Number',
  'form.label.panNumber': 'PAN Number',
  'form.label.aadhaarNumber': 'Aadhaar Number',
  'action.confirm': 'Confirm',
  'form.placeholder.Role': 'Role',
  'form.label.Role': 'Role',
  'text.Roles': 'Role',
  'action.createRole': 'Add Role',
  'text.RoleList': 'Role List',
  'title.helmet.Role': 'Roles',
  'form.placeholder.reported_to': 'Reported To',
  'text.reported_to': 'Reported To',
  'form.user.placeholder.searchRole': 'Search by role name',
  'text.custommessage.RolesData': 'No Roles Found',
  'text.removeRole.description': 'Are you sure, you want to delete role?.',
  'text.TodayBirthDay': 'People Celebrate Birthday on Today',
  'text.StaffName': 'Staff Name',
  'text.birthDayDate': 'Birthday Date',
  'text.emailid': 'Email Id',
  'form.label.message': 'Message',
  'action.SendWishes': 'Send Wishes',
  'text.birthDayWished.description': 'Send Birthday Wishes',
  'form.user.placeholder.staffName': 'Name',

  'text.custommessage.proformainvoicelist': 'No proforma invoice records found',
  'text.custommessage.invoicelist': 'No invoice records found',
  'text.ProformaInvoice': 'Proforma Invoice',
  'text.store.tab.Invoice': 'Invoice',
  'text.store.tab.proformaInvoice': 'Proforma Invoice',
  'text.businessName': 'Business Name',
  'text.invoiceAmount': 'Total Amount',
  'text.invoiceDate': 'Created Date',
  'text.cost': 'Cost',
  'text.ItemCost': 'Item Cost',
  'text.subtotal': 'Sub Total',
  'text.tax': 'Tax',
  'text.discount': 'Discount',
  'text.totalDue': 'Net Pay',
  'text.createdby': 'Created By',
  'text.invoice': 'Invoice',
  'text.description': 'Description',
  'text.quantity': 'Quantity',
  'text.amount': 'Amount',
  'text.paidinvoice': 'Paid',
  'text.PO': 'Proforma Invoice',
  'text.Invoice': 'Invoice',
  'text.billTo': 'Bill To',
  'text.proforma_number': 'Proforma Number',
  'text.invoice_number': 'Invoice Number',
  'action.createInvoice': 'Create Invoice',
  'action.Update': 'Update',
  'action.clear': 'Clear',
  'form.placeholder.search.invoice': 'Search by Business Name or by Invoice Number',
  'text.addItem': 'Add Item',
  'text.createInvoice': 'Create Invoice',
  'form.label.BusinessName': 'Business Name',
  'form.placeholder.BusinessName': 'Select Business Name',
  'form.label.Type': 'Invoice Type',
  'form.placeholder.Type': 'Select Invoice Type',
  'form.label.gst': 'GST %',
  'form.label.cgst': 'CGST %',
  'form.label.sgst': 'SGST %',
  'form.label.igst': 'IGST %',
  'form.placeholder.gst': 'Select GST type from list',
  'form.label.discount': 'Discount in INR',
  'form.placeholder.discount': 'Enter the Discount in INR',
  'text.grandTotal': 'Grand Total',
  'text.BankAccountDetails': 'Bank Account Details',
  'form.label.keynotes': 'Key Notes',
  'form.placeholder.keynotes': 'Enter Key Notes',
  'text.editDomainName': 'Update',
  'text.addEmail': 'Add Email',
  'action.createEmail': 'Create Email',
  'text.store.tab.email': 'Email',
  'text.custommessage.EmailList': 'No data found for Email List',
  'text.emailType': 'Email with Type',
  'text.email.search': 'Search Email',
  'title.helmet.accounts': 'Accounts',
  'text.storeino.tab.accountsInfo': 'Accounts Info',
  'text.storeino.tab.notesInfo': 'Notes',
  'text.storeino.tab.invoices': 'Invoices',
  'text.storeino.tab.enquiry': 'Enquiry',
  'text.storeino.tab.dailyReports': 'Daily Reports',
  'text.storeino.tab.services': 'Services',
  'text.storeino.tab.renewals': 'Renewals',
  'action.followup': 'Today Lead Followup',
  'text.upcomingLeadFollowup': 'Upcoming Lead Followup',
  'text.TodayleadFollowup': 'Lead Followup',
  'form.placeholder.deliveryStatus': 'Email Delivery Status',
  'text.removeEnquiry.description': 'Do you want to remove the selected Enquiry?.',
  'text.comments': 'Comments',
  'text.custommessage.followupData': 'Comments',
  'title.helmet.Dashboard': 'Dashboard',
  'form.label.followup_date': 'Followup Date',
  'text.followupDate': 'Followup Date',
  'action.updateStatus': 'Update Status',
  'text.QuotationFollowup.description': 'Comments',
  'text.custommessage.leadfollowupData': 'No Data for Followup',
  'form.user.placeholder.leadfollowup': 'Search by Business Name',
  'form.label.current_expiry_date': 'Current Expiry Date',
  'form.placeholder.current_expiry_date': 'Current Expiry Date',
  'form.label.new_expiry_date': 'New Expiry Date',
  'form.placeholder.new_expiry_date': 'New Expiry Date',
  'action.AddFollowup': 'Add Followup',
  'text.servicesFollowup.description': 'Followup Description',
  'text.changeValidity.description': 'Validity',
  'text.TodayServiceFollowup': 'Service Followup',
  'text.removeinvoice.description': 'Do you want to delete this proforma?.',
  'text.todayInvoiceFollowup': 'Today Invoice Followup',
  'text.ServiceFollowup.description': 'Followup Description',
  'text.InvoiceFollowup.description': 'Followup Description',
  'text.todayAccountsFiltered': 'Today Accounts Followup',
  'text.upcomingAccountsFiltered': 'Upcoming Accounts Followup',
  'text.accountsFollowup.description': 'Accounts Followup',
  'text.RenewalsInfo': 'Renewal Info',
  'form.placeholder.filteredDays': 'Filter Days',

  'action.createDailyReport': 'Create Daily Report',
  'text.addDailyReport': 'Add Daily Report',
  'form.label.category': 'Category',
  'form.placeholder.category': 'Category',
  'form.label.subject': 'Subject',
  'form.label.description': 'Description',
  'form.placeholder.subject': 'Subject',
  'form.label.time': 'Time Schedule',
  'form.label.start_time': 'Start Time',
  'form.label.end_time': 'End Time',
  'text.viewDailyReport.sno': 'S.No',
  'text.viewDailyReport.business_name': 'Business Name',
  'text.viewDailyReport.subject': 'Subject',
  'text.viewDailyReport.description': 'Description',
  'text.viewDailyReport.start_time': 'Start Time',
  'text.viewDailyReport.end_time': 'End Time',
  'text.viewDailyReport.created_at': 'Created At',
  'text.viewDailyReport.username': 'User',
  'form.user.placeholder.searchDailyReports': 'Search Daily Reports',

  'text.viewservicesData.sno': 'S.No',
  'text.viewservicesData.business_name': 'Business Name',
  'text.viewservicesData.service_name': 'Services Name',
  'text.viewservicesData.started_at': 'Valid From',
  'text.viewservicesData.Validity': 'Validity',
  'text.viewservicesData.username': 'User',
  'text.viewservicesData.created_at': 'Created At',
  'action.createServices': 'Add Services',
  'text.addServices': 'Add Services',
  'form.user.placeholder.searchServices': 'Search Services',
  'form.label.serviceName': 'Service Name',
  'form.placeholder.serviceName': 'Service Name',
  'form.label.started_at': 'Subscription From',
  'form.label.validity': 'Subscribe for years',
  'form.placeholder.validity': 'Validity',
  'text.viewservicesData.expiry_date': 'Validity Till',
  'form.label.validtytill': 'Validity Till',
  'text.custommessage.domainNameList': 'No data for Domain Name List',
  'text.custommessage.hostingList': 'No data for Hosting List',
  'text.business_name': 'Business Name',
  'text.domainname': 'Domain Name',
  'text.serverIpaddress': 'Ip Address - Server Name',
  'text.validity': 'Validity(Yrs)',
  'text.registered_date': 'Registered Date',
  'form.placeholder.started_at': 'Registered Date',
  'text.expiry_date': 'Expiry Date',
  'form.label.followupDate': 'Followup Date',
  'form.label.comments': 'Comments',
  'form.placeholder.expiry_date': 'Expiry Date',
  'text.domainname.search': 'Search Domain Name',
  'text.hosting.search': 'Search Hosting',
  'text.store.tab.domain': 'Domain',
  'form.label.domainname': 'Domain',
  'action.createDomain': 'Add Domain',
  'text.addDomainName': 'Add Domain',
  'form.label.expiry_date': 'Expiry Date',
  'form.placeholder.domainname': 'Enter Domain Name',
  'form.placeholder.DomainName': 'Enter Domain Name',
  'form.label.DomainName': 'Enter Domain Name',
  'form.label.registeredat': 'Registered Date',
  'text.store.tab.hosting': 'Hosting',
  'action.createHosting': 'Create Hosting',
  'text.addHosting': 'Add Hosting',
  'text.editHosting': 'Edit Hosting',
  'form.label.servertype': 'Server Type',
  'form.placeholder.servertype': 'Server Type',
  'form.placeholder.ipaddress': 'IP Address',
  'form.label.ipaddress': 'IP Address',
  'text.sendEmailDescription': 'Do you wan to send Email?.',
  'action.sendEmail': 'Send Email',

  'text.crm': 'CRM',
  'text.website': 'Website',
  'text.graphicdesign': 'Graphic Design',
  'text.digitalmarketing': 'Digital Marketing',
  'text.seo': 'SEO',

  'text.changeAccountManager.description': 'Account Manager',
  'form.label.accountManager': 'Account Manager',
  'form.placeholder.accountManager': 'Account Manager',
  'text.noaccountsnotestoshow': 'No notes to show',
  'text.AddAccountNotes': 'Add Notes',
  'text.updateAccounts': 'Update Accounts',
  'form.label.accountStatus': 'Account Status',
  'text.changeLeadOwner.description': 'Change Lead Owner',
  'text.changeLeadOwner': 'Change Lead Owner',
  'form.label.lead_owner': 'Lead Owner',
  'form.placeholder.changeLeadOwner': 'Select the Lead Owner',
  'text.AddLeadNotes': 'Add Notes for Lead',
  'text.nonotestoshow': 'No Lead Notes to Show',
  'action.convertToAccounts': 'Convert to Accounts',
  'text.convertAccounts.description': 'Are you sure you want to Convert this lead to Accounts?.',

  'text.viewAccounts.sno': 'Sno.',
  'text.viewAccounts.business_name': 'Business Name',
  'text.viewAccounts.emailid': 'Email Id',
  'text.viewAccounts.mobile': 'Mobile',
  'text.viewAccounts.contact_name': 'Contact Name',
  'text.viewAccounts.accountManager': 'Account Manager',
  'text.viewAccounts.accountAssignedto': 'Assigned to',

  'form.label.business_name': 'Business Name',
  'form.placeholder.business_name': 'Business Name',
  'form.label.contact_name': 'Contact Name',
  'form.placeholder.contact_name': 'Contact Name',
  'form.label.emailid': 'Email Id',
  'form.placeholder.emailid': 'Email Id',
  'form.label.mobile': 'Mobile Number',
  'form.label.phone': 'Phone Number',
  'form.placeholder.phone': '0422 264925',
  'form.label.website_url': 'Website URL',
  'form.placeholder.website_url': 'https://www.example.com',
  'form.label.type': 'Type',
  'form.placeholder.type': 'Select the Type from list',
  'form.label.gst_number': 'GST Number',
  'form.placeholder.gst_number': '22AABCU9603R1ZX',
  'form.label.company_since': 'Company Since',
  'form.placeholder.company_since': '1947',
  'form.label.leadstatus': 'Lead Status',
  'form.label.addressline1': 'Address Line 1',
  'form.placeholder.addressline1': 'Address Line 1',
  'form.label.addressline2': 'Address Line 2',
  'form.placeholder.addressline2': 'Address Line 2',
  'form.label.addressline3': 'Address Line 3',
  'form.placeholder.addressline3': 'Address Line 3',
  'form.label.city': 'City',
  'form.placeholder.city': 'City',
  'form.label.landmark': 'Land Mark',
  'form.placeholder.landmark': 'Land Mark',
  'form.label.state': 'State',
  'form.placeholder.state': 'State',
  'form.label.country': 'Country',
  'form.placeholder.country': 'Country',
  'form.label.pincode': 'Pincode',
  'form.placeholder.pincode': 'Pincode',

  'action.active': 'Active',
  'action.inactive': 'Inactive',
  'text.action': 'Action',
  'action.createUser': 'Create User',
  'text.changeAssigned.description': 'Assign Accounts to',

  'text.serialNo': 'S.No',
  'text.name': 'Name',
  'text.mobile': 'Mobile',
  'text.email': 'Email',
  'text.role': 'Role',
  'text.status': 'Status',
  'text.addUser': 'Add User',
  'text.updateUser': 'Update User',
  'form.label.user_status': 'Status',
  'form.label.phoneoptional': 'Mobile Number (Optional)',
  'form.user.placeholder.searchstaff': 'Search by Name or Email',
  'form.label.contactName': 'Name',
  'form.placeholder.contactName': 'Enter the name',
  'form.placeholder.mobile': '(123) 456-7890',
  'text.custommessage.staffData': 'No Staff Records Available',
  'text.removeUser.description': 'Are you sure you want to delete this user?.',

  'text.space': '{count, plural, =1{1} other{#}}',
  'text.default': 'Default',
  'text.makedefault': 'Make this card as default',
  'action.addnewcard': 'Add New Card',
  'action.add': 'Add',
  'action.addcard': 'Add Card',
  'action.save': 'Save',
  'action.yes': 'Yes',
  'action.no': 'No',
  'action.addCustomImage': 'Add Custom Image',
  'text.logo': 'Logo',
  'text.showaddcard': 'Add New Card',
  'text.storedesign': 'Store Design',
  'text.viewStore': 'View Store',
  'form.label.mobileappcoverimage': 'Mobile App Cover Image',
  'form.label.themeColor': 'Theme Color',
  'action.changeColor': 'Change Color',
  'desc.coverImage': 'Cover Image',
  'desc.backgroundImage': 'Cover Image',
  'action.change': 'Change',
  'text.storeino.tab.orders': 'Orders',
  'text.deviceinfo.Settings': 'Settings',
  'text.tabepaysettings': 'Table Pay Settings',
  'text.storeino.tab.tablepaysettings': 'Table Pay Settings',
  'text.tablepaysettings': 'Table Pay Settings',
  'form.label.webstorebackgroundimage': 'Web Store background Image',
  'note.logoSize':
    'Image dimension recommended in JPG or PNG format with the size less than 200kb.',
  'action.resend': 'Resend',
  'action.edit': 'Edit',
  'action.remove': 'Remove',
  'action.retry': 'Retry',
  'action.update': 'Update',
  'action.void': 'Void',
  'text.resendinvoice': 'Resend Invoice',
  'text.showresendinvoice': 'Resend Invoice',
  'text.voidinvoice': 'Void Invoice',
  'text.showvoidinvoice': 'Void Invoice',
  'text.resendinvoice.description': 'Do you want to resend this invoice?',
  'text.voidinvoice.description': 'Do you want to void this invoice?',
  'text.retrypayment': 'Retry Payment',
  'text.showretrypayment': 'Retry Payment',
  'text.showupdatepayment': 'Update Payment',
  'text.retrypayment.description': 'Do you want to retry the payment?',
  'text.updatepayment.description': 'Do you want to update the payment?',

  'title.helmet.store': 'Manage Stores',
  'text.manage.stores': 'Manage Stores',
  'text.store.tab.active': 'Active',
  'text.store.tab.inactive': 'Inactive',
  'text.store.tab.demo': 'Demo',

  'text.active.store.sno': 'S.No',
  'text.active.store.store_name': 'Store Name',
  'text.active.store.phone_number': 'Phone Number',
  'text.active.store.email': 'Email',
  'text.active.store.reseller': 'Reseller',
  'text.active.store.agent': 'Agent',
  'text.active.store.billing_type': 'Payment Method',
  'action.active.store.billing_type': 'Change Payment Method',
  'text.active.store.pos_software': 'Restaurant Software',
  'text.active.store.search': 'Search by store name or email or reseller',

  'text.inactive.store.sno': 'S.No',
  'text.inactive.store.store_name': 'Store Name',
  'text.inactive.store.phone_number': 'Phone Number',
  'text.inactive.store.email': 'Email',
  'text.inactive.store.reseller': 'Reseller',
  'text.inactive.store.agent': 'Agent',
  'text.inactive.store.billing_type': 'Payment Method',
  'action.inactive.store.billing_type': 'Change',
  'text.inactive.store.search': 'Search by store name or email or reseller',

  'text.demo.store.sno': 'S.No',
  'text.demo.store.store_name': 'Store Name',
  'text.demo.store.phone_number': 'Phone Number',
  'text.demo.store.email': 'Email',
  'text.demo.store.reseller': 'Reseller',
  'text.demo.store.agent': 'Agent',
  'text.demo.store.billing_type': 'Payment Method',
  'action.demo.store.billing_type': 'Change',
  'text.demo.store.search': 'Search by store name or email or reseller',

  'title.helmet.storeinfo': 'Store Info',
  'text.storeinfo': 'Store Info',
  'text.storeino.tab.storeinfo': 'Store Info',
  'text.storeino.tab.subscriptioninfo': 'Subscription',
  'text.storeino.tab.deviceinfo': 'Device Info',
  'text.storeino.tab.paymenthistory': 'Payment History',
  'text.storeino.tab.notes': 'Notes',
  'text.storeino.tab.openorder': 'Open Order',
  'text.storeino.tab.closeorder': 'Closed Order',
  'text.storeino.tab.coseorder': 'Closed Order',

  'text.storeino.tab.windowsclient': 'Windows Client',
  'text.storeino.tab.paymentterminal': 'Payment Terminal',

  'title.helmet.deviceinfo': 'Device Info',
  'text.deviceinfo.sno': 'S.No',
  'text.deviceinfo.devicename': 'Device Name',
  'text.deviceinfo.ipaddress': 'IP Address',
  'text.deviceinfo.macaddress': 'MAC Address',
  'text.deviceinfo.lastactivity': 'Last Activity',
  'text.deviceinfo.networkstatus': 'Network Status',
  'text.deviceinfo.logs': 'Logs',
  'text.deviceinfo.devicetype': 'Device Type',
  'text.deviceinfo.viewlogs': 'View Logs',
  'text.devicelogs': 'Device Logs',
  'text.deviceinfo.servicestatus': 'Service Status',
  'text.deviceinfo.servicestatusrunning': 'Running',
  'text.deviceinfo.servicestatusstopped': 'Stopped',
  'text.deviceinfo.version': 'Version',
  'form.paymentterminal.placeholder.search': 'Search by device name',
  'form.windowsclient.placeholder.search': 'Search by device name',
  'text.errorlogsmessage': 'No Error Logs to show',

  // Open Order Table Header

  'text.openorder.sno': 'S.No',
  'text.openorder.orderno': 'Order Number',
  'text.openorder.ordertype': 'Order Type',
  'text.openorder.tableno': 'Table Number',
  'text.openorder.seatno': 'Seat Number',
  'text.openorder.servername': 'Server Name',
  'text.openorder.ordertotal': 'Order Total',
  'text.openorder.paymentstatus': 'Payment Status',
  'text.openorder.order_status': 'Order Status',
  'text.openorder.orderinfo': 'Order Info',
  'text.openorder.orderdetail': 'Order Detail',
  'text.openorder.search': 'Search by order number or user',
  'text.orderamountdue': 'Amount Due',
  'text.orderno': 'Order#',
  'text.orderamountpaidwithtip': 'Amount Paid (Incl.tip)',
  'text.orderamountpaid': 'Amount Paid',
  'text.openorder.user': 'User',

  'text.ordertableno': 'Table Number',
  'text.orderseatno': 'Seat Number',
  'text.orderpaymentstatus': 'Payment Status',
  'text.ordertype': 'Order Type',
  'text.ordertip': 'Tip',
  'text.orderusername': 'User',
  'text.ordercreatedon': 'Created',
  'text.orderinfo': 'Order Summary',
  'text.orderpaymentmethod': 'Payment Method',
  'text.ordertransactiontype': 'Transaction Type',
  'text.orderauthnumber': 'Auth Number',
  'text.ordertransactiondate': 'Transaction Date/Time',

  'text.closeorder.sno': 'S.No',
  'text.closeorder.orderno': 'Order Number',
  'text.closeorder.ordertype': 'Order Type',
  'text.closeorder.tableno': 'Table Number',
  'text.closeorder.seatno': 'Seat Number',
  'text.closeorder.servername': 'Server Name',
  'text.closeorder.ordertotal': 'Order Total',
  'text.closeorder.orderdetail': 'Order Detail',
  'text.closeorder.paymentstatus': 'Payment Status',
  'text.closeorder.search': 'Search by order number or user',
  'text.closeorder.user': 'User',

  'form.storeinfo.label.storename': 'Store Name',

  'text.storedetail.storedetailinfo': 'Store Details',
  'text.storedetail.contactdetails': 'Contact Details',
  'text.storedetail.businessdetails': 'Business Details',
  'action.storedetail.update': 'Update',

  'form.storedetail.label.storename': 'Store Name',
  'form.storedetail.label.storeaddress': 'Address',
  'form.storedetail.label.storecity': 'City',
  'form.storedetail.label.storeprovince': 'Province',
  'form.storedetail.label.storepostalcode': 'Zip/Postal Code',
  'form.storedetail.label.storecountry': 'Country',
  'form.storedetail.label.storebusinessid': 'Business ID',
  'form.storedetail.label.storephone': 'Phone Number',
  'form.storedetail.label.storealternatephone': 'Alt. Phone Number',
  'form.storedetail.label.storeemail': 'Email',
  'form.storedetail.label.storeowner': 'Business Owner',
  'form.storedetail.label.storetype': 'Restaurant Type',
  'form.storedetail.label.storelocations': 'No. of Locations',
  'form.storedetail.label.storeintersection': 'Intersection/Plaza',
  'form.storedetail.label.storecategory': 'Category',
  'form.storedetail.label.storepricerange': 'Price Range',
  'form.storedetail.label.firstName': 'First Name',
  'form.storedetail.label.lastName': 'Last Name',
  'form.storedetail.label.email': 'Email',
  'form.storedetail.label.phone_number': 'Phone Number',
  'form.storedetail.label.alternate_phone_number': 'Alt. Phone Number',
  'form.storedetail.label.businessid': 'Business ID',
  'form.storedetail.label.locationid': 'Location ID',
  'form.storedetail.label.nooflocations': 'No of Locations',
  'form.storedetail.label.category': 'Category',
  'form.storedetail.label.intersectionplaza': 'Intersection Plaza',
  'form.storedetail.label.pricerange': 'Price Range',
  'form.label.businesstype': 'Business Type',
  'form.label.username': 'Username',

  'form.storedetail.placeholder.storename': 'Enter the store name',
  'form.storedetail.placeholder.storetype': 'Enter the Restaurant Type',
  'form.storedetail.placeholder.storeaddress': 'Enter the address',
  'form.storedetail.placeholder.storecity': 'Enter the City',
  'form.storedetail.placeholder.storeprovince': 'Enter the Province',
  'form.storedetail.placeholder.storepostalcode': 'Enter the Zip/Postal code',
  'form.storedetail.placeholder.storecountry': 'Enter the country',
  'form.storedetail.placeholder.firstName': 'Enter the first name',
  'form.storedetail.placeholder.lastName': 'Enter the last name',
  'form.storedetail.placeholder.email': 'Enter the email',
  'form.storedetail.placeholder.phone_number': '(123) 456-7890',
  'form.storedetail.placeholder.alternate_phone_number': '(123) 123-1234',
  'form.storedetail.placeholder.businessid': 'Enter the business ID',
  'form.storedetail.placeholder.locationid': 'Enter the location ID',
  'form.storedetail.placeholder.nooflocations': 'Locations',
  'form.storedetail.placeholder.category': 'Enter the category',
  'form.storedetail.placeholder.intersectionplaza': 'Enter the Intersection Plaza',

  'title.helmet.user': 'Manage Users',
  'text.user': 'Manage Users',
  'text.userinfo.sno': 'S.No',
  'text.userinfo.name': 'Name',
  'text.userinfo.email': 'Email',
  'text.userinfo.phone_number': 'Phone Number',
  'action.userinfo.edit': 'Edit',
  'text.userinfo.status': 'Status',
  'text.userinfo.action': 'Action',
  'text.userinfo.active': 'Active',
  'text.userinfo.inactive': 'Inactive',
  'text.user.placeholder.search': 'Search..',

  'title.helmet.invoice': 'Invoice',
  'text.viewinvoices': 'View Invoice',
  'text.invoices': 'Manage Invoices',
  'text.paidinvoicelabel': 'PAID',
  'text.notpaidinvoicelabel': 'NOT PAID',
  'text.invoices.placeholder.search': 'Search..',

  'text.invoice.creditcardbilling': 'Credit Card Billing',
  'text.invoice.creditcard.paid': 'Paid Invoices',
  'text.invoice.creditcard.unpaid': 'Unpaid Invoices',
  'text.paymenthistory.paid.sno': 'S.No',
  'text.paymenthistory.paid.invoice_no': 'Invoice Number',
  'text.paymenthistory.paid.storename': 'Store Name',
  'text.paymenthistory.paid.invoice_amount': 'Invoice Amount',
  'text.paymenthistory.paid.invoice_date': 'Invoice Date',
  'text.paymenthistory.paid.payment_status': 'Payment Status',
  'text.paymenthistory.paid.payment_method': 'Payment Method',
  'text.paymenthistory.paid.payment_date': 'Payment Date',
  'text.paymenthistory.paid..placeholder.search': 'Search..',

  'text.creditcard.paid.sno': 'S.No',
  'text.creditcard.paid.invoice_no': 'Invoice Number',
  'text.creditcard.paid.storename': 'Store Name',
  'text.creditcard.paid.invoice_amount': 'Invoice Amount',
  'text.creditcard.paid.invoice_date': 'Invoice Date',
  'text.creditcard.paid.payment_status': 'Payment Status',
  'text.creditcard.paid.payment_method': 'Payment Method',
  'text.creditcard.paid.payment_date': 'Payment Date',
  'text.creditcard.paid..placeholder.search': 'Search by invoice number or invoice date',

  'text.invoice.bamboradebit.paid': 'Paid Invoices',
  'text.invoice.bamboradebit.unpaid': 'Unpaid Invoices',
  'text.bamboradebit.paid.sno': 'S.No',
  'text.bamboradebit.paid.invoice_no': 'Invoice Number',
  'text.bamboradebit.paid.storename': 'Store Name',
  'text.bamboradebit.paid.invoice_amount': 'Invoice Amount',
  'text.bamboradebit.paid.invoice_date': 'Invoice Date',
  'text.bamboradebit.paid.payment_status': 'Payment Status',
  'text.bamboradebit.paid.payment_method': 'Payment Method',
  'text.bamboradebit.paid.payment_date': 'Payment Date',
  'text.bamboradebit.paid..placeholder.search': 'Search..',

  'text.invoice.cloverbilling': 'Clover Billing',
  'text.invoice.cloverecommerce.paid': 'Paid Invoices',
  'text.invoice.cloverecommerce.unpaid': 'Unpaid Invoices',
  'text.cloverecommerce.paid.sno': 'S.No',
  'text.cloverecommerce.paid.invoice_no': 'Invoice Number',
  'text.cloverecommerce.paid.storename': 'Store Name',
  'text.cloverecommerce.paid.invoice_amount': 'Invoice Amount',
  'text.cloverecommerce.paid.invoice_date': 'Invoice Date',
  'text.cloverecommerce.paid.payment_status': 'Payment Status',
  'text.cloverecommerce.paid.payment_method': 'Payment Method',
  'text.cloverecommerce.paid.payment_date': 'Payment Date',
  'text.cloverecommerce.paid..placeholder.search': 'Search..',

  'text.cloverecommerce.unpaid.sno': 'S.No',
  'text.cloverecommerce.unpaid.invoice_no': 'Invoice Number',
  'text.cloverecommerce.unpaid.storename': 'Store Name',
  'text.cloverecommerce.unpaid.invoice_amount': 'Invoice Amount',
  'text.cloverecommerce.unpaid.invoice_date': 'Invoice Date',
  'text.cloverecommerce.unpaid.payment_status': 'Payment Status',
  'text.cloverecommerce.unpaid.payment_method': 'Payment Method',
  'text.cloverecommerce.unpaid.payment_date': 'Payment Date',
  'text.cloverecommerce.unpaid..placeholder.search': 'Search..',

  'text.invoice.poyntbilling': 'Poynt Billing',
  'text.invoice.bamborabillingbilling': 'Bambora Billing',

  'text.receiptsettings': 'Receipt Settings',
  'text.profile_pic': 'Profile Pic',
  'text.preferences': 'Preferences',
  'form.label.printreceipt': 'Print receipt after the order is completed?',
  'form.label.printmerchantcopy': 'Print merchant copy after the order is completed?',
  'form.label.footerline': 'Footer Line Text',
  'form.error.footerline.required': 'Please enter the text',
  'form.placeholder.footerline': 'Please enter the footer line text',
  'form.label.idletimeout': 'Idle Timeout (In seconds)',
  'form.error.idletimeout.required': 'Idle timeout required',
  'form.placeholder.idletimeout': '0 means disabled',
  'form.label.tipamount': 'Tip Options',
  'form.label.tip': 'Tip',
  'form.label.tipoptions': 'Choose exactly 3 tip options',

  'form.placeholder.message': 'Type your notes here',

  'text.active': 'Active',
  'text.inactive': 'Inactive',
  'text.demo': 'Demo',
  'text.viewactivitylog': 'Activity Log',
  'text.removeuser.description': 'Are you sure you want to remove the user?',

  'form.placeholder.search': 'Search..',

  'text.stafflist': 'Manage Users',
  'text.totalCount': '{count, plural, =1{1 record} other{# records}}',
  'text.editstaff': 'Update User',

  'text.viewstaff.sno': 'S.No.',
  'text.viewstaff.name': 'Name',
  'text.viewstaff.email': 'Email',
  'text.viewstaff.mobile': 'Phone Number',
  'text.viewstaff.role': 'Role',
  'text.viewstaff.status': 'Status',
  'text.viewstaff.action': 'Action',
  'text.removeUser': 'Remove {name}',
  'text.createstaff': 'Create User',
  'action.createstaff': 'Create User',
  'form.label.role': 'Role',
  'form.label.name': 'Contact Name',
  'form.label.intersection': 'Intersection',

  'form.label.reseller': 'Reseller',
  'form.placeholder.role': 'Select the role',
  'form.placeholder.name': 'Enter the name',
  'form.placeholder.intersection': 'Enter the Intersection',
  'form.placeholder.password': 'Enter the password',
  'form.placeholder.reseller': 'Select the Reseller',
  'action.create': 'Create',
  'form.label.timezone': 'Timezone',
  'form.error.timezone.required': 'Please select the timezone',
  'form.placeholder.timezone': 'Select the timezone',

  'text.changepayment': 'Change Payment Method',
  'form.label.changepayment': 'Payment Method',
  'form.placeholder.changepayment': 'Select payment method',
  'text.billingtype': 'Payment Method',
  'form.label.cardNumber': 'Card Number',
  'form.label.creditCard': 'Credit Card',
  'form.label.cvv': 'CVV',
  'form.label.zipPostalCode': 'Zip/Postal Code',
  'form.placeholder.zipcode': 'Zip/Postal Code',
  'form.placeholder.cardName': 'Name on card',
  'form.label.cardname': 'Name',
  'form.error.required': 'Required',
  'text.billingtype.sno': 'S.No.',
  'text.billingtype.card': 'Payment Method',
  'text.billingtype.action': 'Action',
  'text.Action': 'Action',
  'text.employeeId': 'Employee ID',
  'form.label.reported_to': 'Reported To',
  'form.label.Reporter': 'Reporting Manager',
  'form.placeholder.Reporter': 'Reporting Manager',
  'action.SendSms': 'Send SMS',
  'text.sendSms.description': 'Are you sre you want to send Whatsapp SMS?.',
  'form.label.dateOfBirth': 'Date Of Birth',

  'form.label.newpassword': 'New Password',
  'form.placeholder.newpassword': 'New Password',
  'form.label.confirmpassword': 'Confirm New Password',
  'form.placeholder.confirmpassword': 'Confirm New Password',
  'form.label.oldpassword': 'Current Password',
  'form.placeholder.oldpassword': 'Enter your current Password',
  'topBar.profileMenu.changePassword': 'Change Password',
  'topBar.profileMenu.logout': 'Logout',
  'text.copyright': 'Copyright © 2023 Thirumurugan Grand Properties. All rights reserved.',
  'text.signIn.title': 'Sign in to your account',
  'text.dontHaveAccount': "Don't have an account?",
  'action.signUp': 'Sign Up',
  'action.next': 'Next',
  'action.gotosignin': 'Go to Sign in',
  'action.forgotPassword': 'Forgot password?',
  'action.signIn': 'Sign in',
  'form.label.password': 'Password',
  'form.error.password.max': 'Password must be up to 10 characters',
  'form.error.password.min': 'Password must be at least 8 characters',
  'form.error.password.required': 'Please input the password',
  'form.error.email.required': 'Please input the username or email address',
  'form.error.email.type': 'Invalid email address',
  'form.error.email.max': 'Email address must be up to 25 characters',
  'form.placeholder.email': 'Enter the email',
  'form.label.email': 'Email Id',
  'form.label.active': 'Active',
  'form.label.inactive': 'Inactive',
  'form.placeholder.company': 'Company Name',
  'form.label.company': 'Company Name',
  'form.error.empty.select': 'No matches found.',
  'form.placeholder.province': 'Enter the Province/State',
  'desc.logo': 'Logo Image',
  'title.helmet.orderinfo': 'Order Summary',
  'title.helmet.devicelogs': 'Device Info',
  'text.stacktrace': 'Stacktrace',
  'text.message': 'Message',
  'text.changepayment.description': ' ',
  'text.notes.button_message': 'Add Notes ',
  'form.storedetail.label.status': 'Account Status',
  'form.user.placeholder.search': 'Search by name or email or role',
  'form.label.agent_id': 'Agent ID',
  'text.resetpassword': 'Recover Password',
  'text.resetbutton': 'Reset',
  'title.recoverPassword': 'Recover Password',
  'action.recoverPassword': 'Recover my password',
  'title.resetPassword': 'Reset Password',
  'form.label.password.new': 'New Password',
  'form.label.password.confirm': 'Confirm Password',
  'action.resetPassword': 'Reset my password',
  'form.error.password.match': "Passwords doesn't match",
  'text.alreadyHaveAnAccount': 'Already have an account?',
  'action.Signin': 'Sign in',
  'text.reselleragent': ' Reseller Agent',
  'form.label.pos_software': 'Restaurant Software',
  'form.placeholder.storeinfo.pos_software': 'Restaurant Software',
  'form.placeholder.pos_software': 'Enter the Restaurant Software',
  'form.error.phone.invalid': 'Invalid phone number',
  'form.placeholder.agent_id': 'Agent ID',
  'text.custommessage.openorder': 'No open orders to show',
  'text.custommessage.closedorder': 'No closed orders to show',
  'text.custommessage.windowsclient': 'No windows client to show',
  'text.custommessage.paymentterminal': 'No payment terminal to show',
  'text.custommessage.activestores': 'No active stores to show',
  'text.custommessage.inactivestores': 'No Inactive stores to show',
  'text.custommessage.demostores': 'No Demo account to show',
  'text.custommessage.dailyReportData': 'No Daily Reports to show',
  'text.viewDailyReport.totalTime': 'Total Time',
  'text.custommessage.servicesData': 'No Services for accounts to show',
  'text.custommessage.userinfo': 'No users to show',
  'action.viewReceipt': 'View Receipt',
  'form.label.select.restaurant_software': ' ',
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
